import React from "react";
import { motion } from "framer-motion";
import "./about.css";
import founderImg from "../../assets/about/dritero1.png";

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      when: "beforeChildren"
    }
  }
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  }
};

const imageVariants = {
  hidden: { scale: 0.9, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.8,
      ease: "anticipate"
    }
  }
};

export default function AboutUs() {
  return (
    <motion.div 
      className="about-container"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <motion.p className="about-subtitle" variants={itemVariants}>
        We don't just find candidates – we find the right leaders. With over 16 years of experience in executive search and strategic HR consulting, we help companies worldwide attract top talent that truly fits.
      </motion.p>
      
      <motion.div className="contact-divider1" variants={itemVariants}></motion.div>
      
      <motion.p className="about-subtitle2" variants={itemVariants}>
        Our approach is analytical, discreet, and direct – but above all, personal. Mutual trust is key: candidates appreciate our openness and sensitivity to unique situations because they know we take their interests as seriously as those of our clients. This blend of professional precision and genuine interest makes the difference – and ensures that we successfully fill even the most complex and hard-to-fill positions, where others have failed.
        Our goal is not just to close vacancies but to shape careers sustainably. We apply our structured methodology to the search process, not only evaluating resumes but identifying true decision-makers and high performers – the people behind the resumes.
      </motion.p>
      
      <motion.p className="about-subtitle2" variants={itemVariants}>
        We have successfully placed hundreds of specialists and executives across various industries in 17 countries. Our extensive network spans from CEOs to technical experts and highly specialized niche profiles. We rely on global market analysis, personal recommendations, and targeted outreach.
       <br/>
       <span className='years'> Let's talk – and together, let's find the best candidates for your company.</span>
      </motion.p>

      <motion.div 
        className="about-founder"
        variants={imageVariants}
      >
        <img src={founderImg} alt="Dritëro Lushta" className="founder-image" />
      </motion.div>

      <motion.div className="about-bio" variants={itemVariants}>
        <p>
           Dritëro Lushta is the founder and Managing Director of CAE COMPANY and MOTORSPORTADVISING. 
        </p>
        <p>
         With a background in international consulting, he has advised clients across the automotive, motorsport, industrial, and pharmaceutical sectors - often at the intersection of strategy, technology, and talent. After completing his studies in Biophysics, he joined leading global consultancies, where he gained deep insights into complex organisational structures and decision-making dynamics. Drawing on this experience, he founded his own firms with the aim of offering a more focused, independent, and client-centered approach - one that prioritises analytical precision, discretion, and long-term partnerships over generic solutions.
        </p>
      </motion.div>
    </motion.div>
  );
}